import { createContext, useContext, type ReactNode } from 'react';
import { t as translate, type Lang } from './i18n';
import { pathFor, routeFromPath } from './routes';

const Ctx = createContext<{ lang: Lang; t: (key: string, vars?: Record<string, string | number>) => string }>({
  lang: 'en',
  t: (key) => key,
});

export function LangProvider({ lang, children }: { lang: Lang; children: ReactNode }) {
  const t = (key: string, vars?: Record<string, string | number>) => translate(lang, key, vars);
  return <Ctx.Provider value={{ lang, t }}>{children}</Ctx.Provider>;
}

export function useLang() {
  return useContext(Ctx);
}

/** Internal links use `/ar…` for Arabic. Hash-only links stay on the page. */
export function withLang(href: string, lang: Lang): string {
  if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('http')) return href;
  const url = new URL(href, 'https://iris.invalid');
  const route = routeFromPath(url.pathname);
  return `${pathFor(route, lang)}${url.search}${url.hash}`;
}

export function useHref() {
  const { lang } = useLang();
  return (href: string) => withLang(href, lang);
}
